import { useEffect, useState } from 'react';
import { useAuth } from '../auth';

function RoleRedirect() {
  const { user, loading } = useAuth();
  const [redirected, setRedirected] = useState(false);

  useEffect(() => {
    if (!loading && user && !redirected) {
      const role = user.role;
      console.log('[RoleRedirect] 用户角色:', role);
      
      // 财务角色跳转到工资提报页面
      if (role === '财务' || role.toLowerCase() === 'finance') {
        console.log('[RoleRedirect] 财务角色，跳转到工资提报页面');
        window.location.href = '/wage-declaration';
      } else {
        // 其他角色跳转账单管理页面
        console.log('[RoleRedirect] 非财务角色，跳转账单管理页面');
        window.location.href = '/bills';
      }
      setRedirected(true);
    }
  }, [user, loading, redirected]);

  if (loading || !user) {
    return <div>加载中...</div>;
  }

  return null;
}

export default RoleRedirect;
